import classNames from "classnames";
import React from "react";
import { PulseLoader } from "react-spinners";
import ArrowLeft from "../../../assets/arrow-left-long.svg";
import ArrowRight from "../../../assets/arrow-right-long.svg";

interface ButtonProps {
  type?: "button" | "submit" | "reset";
  label: string;
  variant?: "primary" | "secondary";
  ariaLabel: string;
  size?: "small" | "default";
  buttonWidth?: "full" | "content";
  iconVisibility?: "show" | "hide";
  iconAlignment?: "left" | "right";
  loading?: boolean;
  loadingText?: string;
  isDisabled?: boolean;
  className?: string;
  handleClick?: (e?: any) => void;
}

const Button: React.FC<ButtonProps> = ({
  type,
  label,
  ariaLabel,
  variant,
  size,
  buttonWidth,
  iconVisibility,
  iconAlignment,
  loading,
  isDisabled = false,
  loadingText,
  handleClick,
  className,
}) => {
  if (loading) {
    return (
      <button
        type={type ? type : "button"}
        disabled
        className={`${
          variant === "secondary"
            ? "text-black bg-white border-[1px] border-[#E2E2E2] shadow-buttonPrimary"
            : "text-white bg-brand-default shadow-buttonPrimary"
        } ${
          buttonWidth === "content"
            ? "min-w-[100px] px-4 py-2 text-center"
            : "w-full"
        } ${
          size === "small" ? "h-[40px]" : "h-[56px]"
        } whitespace-nowrap flex-nowrap font-normal mt-2  text-[1.13rem] leading-[127%] rounded-[12px] font-outfit text-center transition duration-500 ease-in-out px-[32px] py-[12px]`}
      >
        <div className="w-full flex items-center justify-center space-x-[8px]">
          <p className="whitespace-nowrap">
            {loadingText ? loadingText : "Loading"}
          </p>
          <PulseLoader
            color={variant === "secondary" ? "#000" : "#fff"}
            size={8}
          />
        </div>
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      data-testid={ariaLabel + "-button"}
      aria-label={ariaLabel + "-button"}
      disabled={isDisabled}
      className={classNames(
        `${isDisabled ? "opacity-50 cursor-not-allowed" : ""} ${
          variant === "secondary"
            ? "text-black bg-white border-[1px] border-[#E2E2E2] shadow-buttonPrimary"
            : "text-white  bg-brand-default shadow-buttonPrimary"
        } ${
          buttonWidth === "content"
            ? "min-w-[100px] px-4 py-2 text-center"
            : "w-full"
        } ${
          size === "small" ? "h-[40px]" : "h-[56px] px-[12px] md:px-[32px]"
        } font-normal mt-2 text-[1.13rem] leading-[127%] rounded-[12px] font-outfit text-center transition duration-500 ease-in-out`,
        className,
      )}
    >
      {iconVisibility === "hide" ? (
        <p className="whitespace-nowrap">{label}</p>
      ) : iconAlignment === "left" ? (
        <div className="w-full flex items-center justify-between space-x-[8px]">
          <img src={ArrowLeft} alt="ArrowRight" />
          <p className="whitespace-nowrap">{label}</p>
        </div>
      ) : (
        <div className="w-full flex items-center justify-between space-x-[8px]">
          <p className="whitespace-nowrap">{label}</p>
          <img src={ArrowRight} alt="ArrowRight" />
        </div>
      )}
    </button>
  );
};

export default Button;
